import { Flex, Skeleton } from "antd";

const RecapAbsentsPresentsSkeleton = () => {
  return (
    <Flex className="mt-4" vertical style={{ width: "100%" }} gap={6}>
      <Flex vertical gap={12}>
        <Skeleton.Input active block size="small" />
        {Array.from({ length: 3 }).map((_, index) => (
          <Flex key={index} align="center" gap={8}>
            <Skeleton.Avatar />
            <Flex vertical gap={2}>
              <Skeleton.Input size={"small"} active />
              <Skeleton.Input size={"small"} active />
            </Flex>
          </Flex>
        ))}
      </Flex>

      <Flex vertical gap={12}>
        <Skeleton.Input active block size="small" />
        {Array.from({ length: 2 }).map((_, index) => (
          <Flex key={index} align="center" gap={8}>
            <Skeleton.Avatar />
            <Flex vertical gap={2}>
              <Skeleton.Input size={"small"} active />
              <Skeleton.Input size={"small"} active />
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default RecapAbsentsPresentsSkeleton;
